import { apiSlice } from './api.api-slice';

export interface ValidateAddressResponse {
  street: string | undefined;
  houseNumber: string | undefined;
  zipCode: string | undefined;
  city: string | undefined;
  countryCode: string | undefined;
  county: string | undefined;
}

export const validateAddressSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    validateAddress: builder.query<ValidateAddressResponse, { query: string }>({
      query: ({ query }) => `/validateAddress?query=${encodeURIComponent(query)}`,
      extraOptions: {
        applyProductPath: false,
      },
    }),
  }),
});

export const { useValidateAddressQuery } = validateAddressSlice;
